import React from 'react'
import { SaveButton } from '../../../../../../../../itrust_common/components/others';
import { visionInsuranceClaimFormEdit } from '../../../../../../../../redux/actions/addOns/rpa/vision_insurance/visionInsuranceClaimFormAction';
import { connect, useDispatch } from 'react-redux';

function SpecteraFormButton(props) {
  const { saving, buttonClasses, backStep, disabled, visionInsuranceClaimForm, editing: { activeModule }, actionLabel } = props
  const dispatch = useDispatch()
  const currentStep = activeModule || 'first'

  const handleBackClick = () => {
    let step = backStep
    if (backStep === 'auto') {
      const eligibilityData = visionInsuranceClaimForm?.eligibility?.data || []
      const hasMaterialsBenefit = eligibilityData.some(item =>
        ['Frame Benefit', 'Lens Benefit', 'Contacts Benefit'].includes(item.service_type) && item.active
      )
      step = (visionInsuranceClaimForm.exams?.exam?.is_cpt2_selected === 'yes' || hasMaterialsBenefit) ? 'final' : 'second'
    }
    dispatch(visionInsuranceClaimFormEdit({ activeModule: step }));
  };

  return (
    <div className='d-flex justify-content-end align-items-center mt-6'>
      {currentStep !== 'first' && <button type="button" className={`btn btn-outline-primary mr-5 px-7 ${buttonClasses}`} onClick={handleBackClick}>Back</button>}
      <SaveButton
        saving={saving}
        disabled={disabled}
        buttonClasses={`px-7 ${buttonClasses}`}
        label={actionLabel || 'Next'}
        title="Please fill all required fields"
      />
    </div>
  )
}

const mapStateToProps = (state) => {
  const { visionInsuranceClaimForm: { visionInsuranceClaimForm, saving, editing } } = state

  return {
    visionInsuranceClaimForm,
    saving,
    editing
  }
}

export default connect(mapStateToProps)(SpecteraFormButton)
